export const ACTIONS = {
  SET_IS_APP_LOADING: "SET_IS_APP_LOADING",
  SET_IS_CALLING_API: "SET_IS_CALLING_API",
  TOGGLE_INFO_MODAL: "TOGGLE_INFO_MODAL",
  OPEN_FATAL_ERROR_REFRESH_MODAL: "OPEN_FATAL_ERROR_REFRESH_MODAL",
  CLOSE_FATAL_ERROR_REFRESH_MODAL: "CLOSE_FATAL_ERROR_REFRESH_MODAL",
  SET_PROGRESS_ALERT: "SET_PROGRESS_ALERT",
  RESET_PROGRESS_ALERT: "RESET_PROGRESS_ALERT",
  SHOW_CREATED_COURSE_MODAL: "SHOW_CREATED_COURSE_MODAL",
  CLOSE_APP_REDIRECT: "CLOSE_APP_REDIRECT",
  BACK_TO_FORM: "BACK_TO_FORM",
  SET_COURSES: "SET_COURSES"
};
